export default __webpack_public_path__ + "static/media/tablet-alt-solid.2dda17e9.svg";